@if (visible()) {
  <div [class]="cssClass()">
    <h4>{{ header() }}</h4>
    <p>{{ text() }}</p>
  </div>
}